import React from 'react';
import { TabProps } from './types';

const Tab7GoalsChallenges: React.FC<TabProps> = ({
  formData,
  updateNestedField,
}) => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-semibold text-gray-900">Section 7: Goals & Challenges</h3>

      {/* Primary Goals */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Primary Goals</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Primary Goal</label>
            <select
              value={formData.goals_challenges?.primary_goal || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                primary_goal: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="more_accuracy">More Accuracy (less dispersion)</option>
              <option value="more_distance">More Distance</option>
              <option value="consistent_distance">Consistent Distance</option>
              <option value="other">Other</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Target Handicap</label>
            <input
              type="number"
              min="-5"
              max="40"
              step="0.1"
              value={formData.goals_challenges?.target_handicap || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                target_handicap: e.target.value ? parseFloat(e.target.value) : undefined
              })}
              placeholder="Desired handicap improvement"
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            />
          </div>
        </div>
      </div>

      {/* Challenges & Frustrations */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Challenges & Frustrations</h4>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Biggest Frustration</label>
            <select
              value={formData.goals_challenges?.biggest_frustration || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                biggest_frustration: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="inconsistent">Inconsistent</option>
              <option value="distance">Distance</option>
              <option value="inaccurate">Inaccurate</option>
              <option value="mental">Mental</option>
            </select>
          </div>
        </div>
      </div>

      {/* Timeline & Commitment */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Timeline & Commitment</h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Purchase Timeline</label>
            <select
              value={formData.goals_challenges?.purchase_timeline || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                purchase_timeline: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="immediate">Immediate</option>
              <option value="6_months">6 Months</option>
              <option value="1_year">1 Year</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Practice Frequency</label>
            <select
              value={formData.goals_challenges?.practice_frequency || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                practice_frequency: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="1/week">1/week</option>
              <option value="2+/week">2+/week</option>
              <option value="1-3/month">1-3/month</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Lesson Frequency</label>
            <select
              value={formData.goals_challenges?.lesson_frequency || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                lesson_frequency: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="weekly">Weekly</option>
              <option value="monthly">Monthly</option>
              <option value="seasonally">Seasonally</option>
              <option value="never">Never</option>
            </select>
          </div>
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">Technology Comfort</label>
            <select
              value={formData.goals_challenges?.technology_comfort || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                technology_comfort: e.target.value || undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>
        </div>
      </div>

      {/* Seasonal Considerations */}
      <div className="bg-gray-50 p-4 rounded-lg">
        <h4 className="font-medium text-gray-900 mb-3">Seasonal Considerations</h4>
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="block text-base font-medium text-gray-700 mb-2">In Season/Off Season (for colder climates)</label>
            <select
              value={formData.goals_challenges?.in_season_off_season?.toString() || ''}
              onChange={(e) => updateNestedField('goals_challenges', {
                in_season_off_season: e.target.value === 'true' ? true : e.target.value === 'false' ? false : undefined
              })}
              className="mt-1 block w-full text-base px-4 py-3 md:py-2 min-h-[44px] rounded-md border-gray-300 shadow-sm focus:border-green-ink focus:ring-green-ink"
            >
              <option value="">Select</option>
              <option value="true">Yes (seasonal golfer)</option>
              <option value="false">No (year-round golfer)</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tab7GoalsChallenges;
